import { createHandlerChainRunner, Handler, HandlerProps, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { getTransactionTypes, TransactionType } from "@tggstore/Services/CommonServices";

type Parameter = ApiParameter & HasOnSuccess<TransactionType[]>;

type Props = {
    apiResult: TransactionType[];
    apiParameter: ApiParameter;
};

type HandlerType = Handler<Parameter, Props>;

const dispatchIsLoading = (isLoading: boolean, props: HandlerProps<Parameter, Props>) => {
    props.dispatch({
        type: "Custom/TransactionTypeOptionsState/Loading",
        isLoading,
    } as any);
};

export const SetLoadingTrue: HandlerType = props => {
    dispatchIsLoading(true, props);
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        const result = await getTransactionTypes();
        if (result.successful) {
            props.apiResult = result.result;

            props.dispatch({
                type: "Custom/TransactionTypeOptionsState/SetTransactionTypes",
                transactionTypes: result.result,
            } as any);
        } else {
            throw new Error(result.errorMessage);
        }
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Custom/TransactionTypeOptionsState/FailedToLoad",
                message: "Failed to load transaction types",
            } as any);
            return false;
        }
        throw error;
    }
};

export const SetLoadingFalse: HandlerType = props => {
    dispatchIsLoading(false, props);
};

export const chain = [SetLoadingTrue, RequestDataFromApi, SetLoadingFalse];

const loadTransactionTypeOptions = createHandlerChainRunner(chain, "LoadTransactionTypeOptions");
export default loadTransactionTypeOptions;
